import {
  AccountingActionEnum,
  AccountingActionCategory,
} from "./accounting-action-enum";

export const ActionCategoryMapping = Object.freeze({
  [AccountingActionCategory.GOODS_AND_SERVICES]: [
    AccountingActionEnum.INVENTORY,
    AccountingActionEnum.SALES_REVENUE,
    AccountingActionEnum.SALES_RETURN,
    AccountingActionEnum.SALES_DISCOUNT,
    AccountingActionEnum.GOODS_IN_TRANSIT,
    AccountingActionEnum.COST_OF_GOODS_SOLD,
    AccountingActionEnum.PURCHASE_RETURN,
    AccountingActionEnum.EXPENSE,
    AccountingActionEnum.UNBILLED_PAYABLES,
  ],
  [AccountingActionCategory.COMPANY]: [
    AccountingActionEnum.OPENING_BALANCE_EQUITY,
    AccountingActionEnum.RETAINED_EARNINGS,
    AccountingActionEnum.INCOME_TAX_EXPENSE,
    AccountingActionEnum.PPH21_PAYABLE,
    AccountingActionEnum.PENSION_PAYABLE,
    AccountingActionEnum.HEALTH_INSURANCE_PAYABLE,
    AccountingActionEnum.EMPLOYEE_LOAN_RECEIVABLE,
    AccountingActionEnum.LOAN_INTEREST_RECEIVABLE,
    AccountingActionEnum.DEFERRED_INTEREST_INCOME,
    AccountingActionEnum.LOAN_INTEREST_INCOME,
    AccountingActionEnum.LOAN_PENALTY_INCOME,
  ],
  [AccountingActionCategory.SALES_PURCHASE]: [
    AccountingActionEnum.PAYMENT_DISCOUNT,
    AccountingActionEnum.TAX_ROUNDING_DIFFERENCE,
  ],
  [AccountingActionCategory.INVENTORY]: [
    AccountingActionEnum.INVENTORY_ADJUSTMENT,
    AccountingActionEnum.STOCK_OPNAME_VARIANCE,
    AccountingActionEnum.WORK_IN_PROGRESS,
    AccountingActionEnum.JOB_COST_VARIANCE,
  ],
  [AccountingActionCategory.CUSTOMER]: [
    AccountingActionEnum.ACCOUNTS_RECEIVABLE,
    AccountingActionEnum.SALES_DOWN_PAYMENT,
    AccountingActionEnum.SALES_REVENUE,
    AccountingActionEnum.ITEM_DISCOUNT,
    AccountingActionEnum.COST_OF_GOODS_SOLD,
    AccountingActionEnum.SALES_RETURN,
    AccountingActionEnum.SALES_DISCOUNT,
  ],
  [AccountingActionCategory.SUPPLIER]: [
    AccountingActionEnum.ACCOUNTS_PAYABLE,
    AccountingActionEnum.PURCHASE_DOWN_PAYMENT,
  ],
});
